// ═══════════════════════════════════════════════════════════════════════════════
// viewAs.js — LEAN-04 Phase 2: admin "view-as" client plumbing.
//
// When an admin super-user views a specific tenant (one clinic / one
// anaesthetist), every /api request must carry an X-Sykes-View-As header so the
// server narrows the admin's data scope to that tenant (see server middleware +
// tenant-scope.cjs). The clinic/anaesthetist portals fetch the API from MANY
// places (APIStore AND direct fetch() calls in components), so rather than
// thread a param through all of them we patch fetch() once and attach the
// header centrally — but ONLY while a selector is active, and ONLY to our API.
//
// Safety: the header is advisory; the server applies it solely for admins
// (role-gated middleware). When the selector is null the patched fetch is a
// transparent passthrough.
// ═══════════════════════════════════════════════════════════════════════════════

let _selector = null;   // 'clinic:<id>' | 'anaesthetist:<id>' | null
let _patched = false;

function ensurePatched() {
  if (_patched || typeof window === 'undefined' || !window.fetch) return;
  _patched = true;
  const orig = window.fetch.bind(window);
  window.fetch = (input, init) => {
    if (_selector) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/api/') >= 0) {
        init = { ...(init || {}) };
        init.headers = { ...(init.headers || {}), 'X-Sykes-View-As': _selector };
      }
    }
    return orig(input, init);
  };
}

/** Activate view-as for a tenant. sel: 'clinic:<id>' | 'anaesthetist:<id>'. */
export function setViewAs(sel) {
  _selector = sel || null;
  if (_selector) ensurePatched();
}

/** Clear view-as (admin returns to their own full scope). */
export function clearViewAs() {
  _selector = null;
}

export function getViewAs() {
  return _selector;
}
